export default __webpack_public_path__ + "static/media/0xb25e20de2f2ebb4cffd4d16a55c7b395e8a94762.34f72a1e.webp";